import { useContext } from "react";
import { CoachReviewsContext } from "../Contexts/coach-reviews.context";

export const useActiveCoachReviewsContext = () => {
	const ctx = useContext(CoachReviewsContext);
	if (!ctx) throw new Error("useActiveCoachReviewsContext must be used inside CoachReviewsProvider");
	return ctx;
};
